import React, {useState} from "react";
import {ConstanciaContext} from "./ConstanciaContext";
import {useParams} from "react-router";

export function ProvideConstancia({ children }) {
    const data_alumno = useProvideConstancia();

    return (
        <ConstanciaContext.Provider value={data_alumno}>
            {children}
        </ConstanciaContext.Provider>
    );
}

function useProvideConstancia() {
    const {data_alumno} = useParams();

    return {
        data_alumno,
    };
}

